import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const HaishaKiboKbn = props => {
  return <Dropdown.Static kubunKey='haisha_kibo_kbn' {...props} />
}
